/* eslint-disable default-case */
import { updatedAt } from './updatedAt';

const convertDateIntoObject = (date, format) => {
  if (date) {
    let dateString;
    let dateObj;
    let displayVal;
    switch (format) {
      case 'yyyy-mm-dd':
        dateString = date.match(/^(\d{4})-(\d{2})-(\d{2})$/);
        dateObj = new Date(dateString[3], dateString[2] - 1, dateString[1]); // yyyy-mm-dd
        return dateObj;
      case 'dd-mm-yyyy':
        dateString = date.match(/^(\d{2})-(\d{2})-(\d{4})$/);
        dateObj = new Date(dateString[3], dateString[2] - 1, dateString[1]); // yyyy-mm-dd
        return dateObj;
      case 'dd/mm/yyyy':
        dateString = date.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
        dateObj = new Date(dateString[3], dateString[2] - 1, dateString[1]); // yyyy-mm-dd
        return dateObj;
      case 'dd/mm/yyyy hh:mm:ss':
        dateString = date.match(
          /^(\d{2})\/(\d{2})\/(\d{4})\s(\d{2})[:](\d{2})[:](\d{2})$/,
        );
        dateObj = new Date(
          dateString[3],
          dateString[2] - 1,
          dateString[1],
          dateString[4],
          dateString[5],
          dateString[6],
        ); // yyyy-mm-dd
        return dateObj;
      case 'dd/mm/yyyy, hh:mm:ss':
        dateString = date.match(
          /^(\d{2})\/(\d{2})\/(\d{4})[,]\s(\d{2})[:](\d{2})[:](\d{2})$/,
        );
        dateObj = new Date(
          dateString[3],
          dateString[2] - 1,
          dateString[1],
          dateString[4],
          dateString[5],
          dateString[6],
        ); // yyyy-mm-dd
        displayVal = updatedAt(dateObj, true);
        return displayVal;
    }
  }
};
export default convertDateIntoObject;
